import React, { useState, useEffect } from 'react';
import { FileText, Shield, Users, Scale, Lock, Building2, AlertTriangle, BookOpen, Loader } from 'lucide-react';
import { getPageBySlug } from '../lib/pageService';

const KullaniciSozlesmesi = () => {
  const [pageContent, setPageContent] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPageContent = async () => {
      try {
        setIsLoading(true);
        const page = await getPageBySlug('kullanici-sozlesmesi');
        if (page && page.content) {
          setPageContent(page.content);
        } else {
          // If no content is found, we'll use the default content
          setPageContent(null);
        }
      } catch (err) {
        console.error('Error fetching page content:', err);
        setError('Sayfa içeriği yüklenirken bir hata oluştu.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchPageContent();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="flex items-center gap-3">
          <Loader className="w-6 h-6 text-[#F7BA45] animate-spin" />
          <span className="text-slate-600">Sayfa yükleniyor...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-gradient-to-b from-[#F7BA45]/20 to-slate-50 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6 text-center">
              Kullanıcı Sözleşmesi
            </h1>
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-slate-200">
              {pageContent ? (
                <div dangerouslySetInnerHTML={{ __html: pageContent }} />
              ) : error ? (
                <div className="text-center text-red-500">
                  <p>{error}</p>
                </div>
              ) : (
                <div className="prose prose-slate max-w-none space-y-8">
                  {/* Sections A-D */}
                  <div className="space-y-8">
                    <div className="flex items-start gap-4">
                      <div className="bg-[#F7BA45]/10 p-3 rounded-lg flex-shrink-0">
                        <Users className="w-6 h-6 text-[#F7BA45]" />
                      </div>
                      <div>
                        <h2 className="text-2xl font-semibold text-slate-800 mb-4">A. Taraflar</h2>
                        <p className="text-slate-600 leading-relaxed">
                          İşbu Kullanıcı Sözleşmesi (Bundan böyle "Sözleşme" olarak anılacaktır), Türkiye Cumhuriyeti kanunları uyarınca kurulmuş ve mevcudiyetini sürdüren bir anonim şirket olan, 0623193681000001 MERSİS numarası ile İstanbul Ticaret Sicil Müdürlüğüne 418611-5 numarası ile kayıtşı bulunan KREDİPARK ANONİM ŞİRKETİ (Bundan böyle kısaca "KREDİPARK" olarak anılacaktır) ile www.kredipark.com websitesi (Bundan böyle "Website" olarak anılacaktır) kullanıcısı (Bundan böyle "Kullanıcı" olarak anılacaktır) arasında, Kullanıcı'nın Website'yi kullanmasına yönelik olarak ve Website'nin bulunduğu elektronik ortamda Kullanıcı tarafından onaylanması anında düzenlenmiştir. Kullanıcı, Website'ye giriş yaparak Sözleşme'nin tamamını okuduğunu, içeriğini bütünü ile anladığını ve tüm hükümlerini onayladığını kabul ve beyan eder. (KREDİPARK ve Kullanıcı bundan böyle birlikte "Taraflar" olarak anılacaktır.)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KullaniciSozlesmesi;